import { Fragment } from 'react';

interface MultilineFieldErrorProps {
  message?: string;
}

/**
 * A validation message can bundle several unmet requirements at once (see passwordRules in
 * ValidationHelper), joined with \n - this puts each one on its own line rather than running
 * them together as one paragraph.
 */
const MultilineFieldError = ({ message }: MultilineFieldErrorProps) => {
  if (!message) return null;

  const lines = message.split('\n');

  return (
    <>
      {lines.map((line, index) => (
        <Fragment key={index}>
          {line}
          {index < lines.length - 1 && <br />}
        </Fragment>
      ))}
    </>
  );
};

export default MultilineFieldError;
